export default __webpack_public_path__ + "static/media/banner3.28d4cb52.jpg";